import { getPropertyId } from "common/"
export const APP = '/:propertyId',
  CREATE_CAMPAIGN = APP + '/campaign',
  EDIT_CAMPAIGN = APP + '/campaign/:id/:step?',
  PREVIEW = 'preview',
  PUBLISH = 'publish',
  SCHEDULE = 'schedule',
  APPROVALS = APP + '/approvals',
  SETTINGS = APP + '/settings',
  REPORT_PROPERTY = APP + "/by-property/:step?",
  REPORT_ALL_CAMPAIGN = APP + "/by-campaigns/:step?",
  REPORT_CAMPAIGN = APP + "/by-campaign/:step?",
  REPORT_CONTACT = APP + "/by-contact/:step?",
  REPORT_ANALYTICS = APP + "/my-analytics";

export const getAppPath = (propertyId) => {
  return APP.replace(':propertyId', propertyId || getPropertyId());
}

export const getCreateEventPath = (propertyId) => {
  return CREATE_CAMPAIGN.replace(':propertyId', propertyId || getPropertyId());
}

export const getEditEventPath = (event, preview) => {
  let id = event.id;
  let path = EDIT_CAMPAIGN.replace(':id', id);
  path = path.replace(':propertyId', getPropertyId());

  if (preview) return path.replace(':step?', PREVIEW)

  switch (event.status) {
    case 'published':
      return path.replace(':step?', SCHEDULE)
    case 'publish_scheduled':
      return path.replace(':step?', PUBLISH)
    default: return path.replace(':step?', "");
  }
}

export const getCampaignEditPath = (id) => {
  let path = EDIT_CAMPAIGN.replace(':id', id);
  path = path.replace(':propertyId', getPropertyId());
  return path.replace(':step?', "");
};

export const getPublishPath = (event) => {
  let path = EDIT_CAMPAIGN.replace(':id', event.id);
  path = path.replace(':propertyId', getPropertyId());
  return path.replace(':step?', PUBLISH);
};

export const getScheduleInvitePath = (event) => {
  let path = EDIT_CAMPAIGN.replace(':id', event.id);
  path = path.replace(':propertyId', getPropertyId());
  return path.replace(':step?', SCHEDULE);
};

export const getQueryParams = () => {
  let params = {}
  window.location.search.substr(1).split("&").forEach(key_value => {
    if (key_value.split("=")[0] === "properties")
      params[key_value.split("=")[0]] = key_value.substr(11)
    else
      params[key_value.split("=")[0]] = key_value.split("=")[1] ? key_value.split("=")[1].replace(/%20/g, " ").trim() : ""
  })
  return params;
}

export const getEventRoutesParameters = () => {
  const route = window.location.pathname.split("/").filter(i => i);
  const id = route[2];
  const step = route[3];
  return { id, step }
}



